import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';

import { PageDto } from './../../shared/page.dto';
import { PageQueriesModel } from './../../shared/page-queries.model';
import { AccountingRuleFileDto } from './../accounting-rule-file.dto';

@Injectable()
export class AccountingRuleProcessingRestService {
  constructor(private http: HttpClient) {}

  list(queries: PageQueriesModel) {
    const url = this.apiUrlRuleFiles();
    const options = {
      params: queries.getParams()
    };

    return this.http.get<PageDto<AccountingRuleFileDto>>(url, options).pipe(
      map(d => {
        const page = new PageDto(d);
        page.content = d.content.map(i => new AccountingRuleFileDto(i));
        return page;
      })
    );
  }

  create(
    d: File,
    source: string,
    createdBy: string,
    accountType: string,
    description: string
  ) {
    const url = this.apiUrlUploadInboundRuleFile(
      source,
      createdBy,
      accountType,
      description
    );

    const formData = new FormData();
    formData.append('file', d);
    const headers = new HttpHeaders();
    headers.append('Content-Type', 'multipart/form-data');
    headers.append('Accept', '*/*');
    return this.http
      .post<AccountingRuleFileDto>(url, formData, { headers })
      .pipe(map(data => new AccountingRuleFileDto(data)));
  }

  apply(
    source: string,
    createdBy: string,
    accountType: string,
    version: string
  ) {
    const url = this.apiUrlApplyRuleFile(
      source,
      createdBy,
      accountType,
      version
    );
    return this.http.post<AccountingRuleFileDto>(url, null);
  }

  downloadFile(fileId: string) {
    return `api/cspaccountingprocessing/accountingrulefiles/download/${fileId}`;
  }

  private apiUrlApplyRuleFile(
    source: string,
    createdBy: string,
    accountType: string,
    version: string
  ) {
    return `api/cspaccountingprocessing/accountingrulefiles/accountingrulefile/setActive?
					source=${source}&createdBy=${createdBy}&accountType=${accountType}&version=${version}`;
  }

  private apiUrlRuleFiles() {
    return `api/cspaccountingprocessing/accountingrulefiles`;
  }

  private apiUrlUploadInboundRuleFile(
    source: string,
    createdBy: string,
    accountType: string,
    description: string
  ) {
    return `api/cspaccountingprocessing/accountingrulefiles/upload?
					source=${source}&createdBy=${createdBy}&accountType=${accountType}&description=${description}`;
  }
}
